import { z } from 'zod';

export const schemaConsorsAccountNumber = z
    .string()
    .min(1)
    .max(10)
    .regex(/^[0-9]+$/, 'Invalid characters');
